import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgShuiModule } from '@shui/angular';
import { TranslocoModule } from '@jsverse/transloco';
import { MarkdownPipe } from 'src/core/pipes/markdown.pipe';
import { AppConfigService } from 'src/core/services/appconfig.service';

@Component({
  selector: 'app-info-modal',
  imports: [CommonModule, NgShuiModule, MarkdownPipe, TranslocoModule],
  templateUrl: './info-modal.component.html',
  styleUrl: './info-modal.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class InfoModalComponent {
  aiCapabilities: any[] = [];
  instrumentInformation: any[] = [];

  constructor(private appConfigService: AppConfigService) {}

  ngOnInit(): void {
    this.appConfigService.aiCapabilities$.subscribe((capabilities) => {
      this.aiCapabilities = Array.isArray(capabilities) ? capabilities : [];
    });

    this.appConfigService.config$.subscribe((config) => {
      this.instrumentInformation = Array.isArray(config) ? config : [];
    });
  }
}